import React, { useState, useEffect } from 'react';
import { getVoiceSettings, saveVoiceSettings, speakAnnouncement, playSound } from '../utils/blindTimerVoice';

function VoiceSettings({ onClose }) {
  const [settings, setSettings] = useState(getVoiceSettings());

  useEffect(() => {
    saveVoiceSettings(settings);
  }, [settings]);

  const update = (patch) => setSettings({ ...settings, ...patch });

  const test = () => {
    if (settings.soundEnabled) playSound('beep', 200);
    if (settings.enabled) speakAnnouncement('Test announcement. Blinds are now 100 and 200.', settings);
  };

  return (
    <div onClick={onClose} style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#1a2a3e', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: 16, padding: 28, maxWidth: 480, width: '100%', color: '#fff'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ margin: 0 }}>Voice & Sound Settings</h2>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: '#fff',
            fontSize: 28, cursor: 'pointer'
          }}>&times;</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Toggle label="🔊 Voice announcements" checked={settings.enabled} onChange={(v) => update({ enabled: v })} />
          <Toggle label="🎵 Sound effects" checked={settings.soundEnabled} onChange={(v) => update({ soundEnabled: v })} />

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#d4a843', marginBottom: 12 }}>WARNINGS</div>
            <Toggle label="5 minute warning" checked={settings.fiveMinEnabled !== false} onChange={(v) => update({ fiveMinEnabled: v })} />
            <Toggle label="1 minute warning" checked={settings.oneMinEnabled !== false} onChange={(v) => update({ oneMinEnabled: v })} />
            <Toggle label="30 second warning" checked={settings.thirtySecEnabled === true} onChange={(v) => update({ thirtySecEnabled: v })} />
          </div>

          <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', paddingTop: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#d4a843', marginBottom: 12 }}>VOICE</div>
            <RangeSlider label="Speed" value={settings.voiceRate ?? 1} min={0.5} max={2} step={0.1} onChange={(v) => update({ voiceRate: v })} />
            <RangeSlider label="Pitch" value={settings.voicePitch ?? 1} min={0.5} max={2} step={0.1} onChange={(v) => update({ voicePitch: v })} />
            <RangeSlider label="Volume" value={settings.voiceVolume ?? 1} min={0} max={1} step={0.1} onChange={(v) => update({ voiceVolume: v })} />
          </div>

          <button onClick={test} style={{
            background: '#d4a843', color: '#0a1628', border: 'none',
            padding: '12px 24px', borderRadius: 8, fontWeight: 700, cursor: 'pointer',
            marginTop: 8
          }}>🔊 Test</button>
        </div>
      </div>
    </div>
  );
}

function Toggle({ label, checked, onChange }) {
  return (
    <label style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}>
      <span style={{ fontSize: 14 }}>{label}</span>
      <div onClick={() => onChange(!checked)} style={{
        width: 44, height: 24, borderRadius: 12,
        background: checked ? '#2ecc71' : 'rgba(255,255,255,0.2)',
        position: 'relative', transition: 'background 0.2s'
      }}>
        <div style={{
          position: 'absolute', top: 2, left: checked ? 22 : 2,
          width: 20, height: 20, borderRadius: '50%', background: '#fff',
          transition: 'left 0.2s'
        }} />
      </div>
    </label>
  );
}

function RangeSlider({ label, value, min, max, step, onChange }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
        <span>{label}</span>
        <span style={{ color: 'rgba(255,255,255,0.5)' }}>{value.toFixed(1)}</span>
      </div>
      <input type="range" min={min} max={max} step={step} value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        style={{ width: '100%' }}
      />
    </div>
  );
}

export default VoiceSettings;
